import { Component } from '@angular/core';
import { NotFoundOrAuthorizedService } from '../../../core/services/not-found-or-authorized.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from 'ngx-flexible-layout';

@Component({
	selector: 'app-incompatible-browser',
	templateUrl: './incompatible-browser.component.html',
	styleUrls: ['./incompatible-browser.component.scss'],
	imports: [
		MatCardModule,
		MatIconModule,
		FlexLayoutModule
	]
})
export class IncompatibleBrowserComponent {

	constructor(
		private readonly notFoundOrAuthorizedService: NotFoundOrAuthorizedService
	) {
		this.notFoundOrAuthorizedService.hide();
	}
}
